/*
 * Gift-wrap option bridge (PRD v3).
 * The "Add gift wrap & personalized card ($5)" checkbox does NOT add to cart directly.
 * - Checking it opens the gift modal (mm-gift-wrap-modal), where the shopper enters
 *   From / To / Message; the modal adds the gift product WITH the `_no_discount` line
 *   property (so it is never eligible for a promo).
 * - Unchecking it removes the gift line cleanly via the cart instance (no reload, no error).
 * The checkbox's checked state is set server-side by Liquid on every drawer render.
 */
(function () {
  var GIFT_HANDLE = 'make-it-a-gift';
  var GIFT_VARIANT = 49921886519573;
  var busy = false;

  document.body.addEventListener('change', function (e) {
    var cb = e.target;
    if (!cb || cb.id !== 'cart-upsell-checkbox') return;

    if (cb.checked) {
      // Enabling gift wrap → open the modal instead of adding directly.
      // Revert the visual check; a successful modal add re-renders it checked.
      cb.checked = false;
      if (typeof window.mmOpenGiftWrap === 'function') {
        window.mmOpenGiftWrap();
      }
    } else {
      // Disabling gift wrap → remove the gift line.
      removeGift(cb);
    }
  });

  function removeGift(cb) {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var idx = cart.items.findIndex(function (it) {
          return it.handle === GIFT_HANDLE || it.variant_id === GIFT_VARIANT;
        });
        if (idx === -1) { busy = false; return; }
        var line = idx + 1;
        var cartItems =
          document.querySelector('cart-drawer-items') || document.querySelector('cart-items');
        if (cartItems && typeof cartItems.updateQuantity === 'function') {
          // Same clean path the Remove link uses — refreshes the drawer in place.
          cartItems.updateQuantity(line, 0);
          setTimeout(function () { busy = false; }, 800);
        } else {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ line: line, quantity: 0 }),
          })
            .then(function () { document.dispatchEvent(new CustomEvent('cartUpdated')); })
            .finally(function () { busy = false; });
        }
      })
      .catch(function () {
        busy = false;
        if (cb) cb.checked = true; // restore on failure
      });
  }

  // Keep the checkbox in sync with cart state after the modal's partial refresh
  // (normal drawer refreshes already re-render it checked via Liquid).
  function sync() {
    var cb = document.querySelector('#cart-upsell-checkbox');
    if (!cb) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var has = cart.items.some(function (it) {
          return it.handle === GIFT_HANDLE || it.variant_id === GIFT_VARIANT;
        });
        if (cb.checked !== has) cb.checked = has;
      })
      .catch(function () {});
  }
  ['cart:update', 'cart:refresh', 'cartUpdated'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(sync, 400); });
  });
})();
